import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const DoubleArrowUpIcon = observer(
    'DoubleArrowUpIcon',
    ({ className, onClick }: SvgIconPropsType): JSX.Element => {
        return (
            <SvgIcon
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                className={className}
                onClick={onClick}
            >
                <mask
                    id='a_DoubleArrowUpIcon'
                    width='16'
                    height='16'
                    x='0'
                    y='0'
                    maskUnits='userSpaceOnUse'
                    style={{ maskType: 'alpha' }}
                >
                    <path
                        fill='#D9D9D9'
                        d='M0 0h16v16H0z'
                    />
                </mask>
                <g mask='url(#a_DoubleArrowUpIcon)'>
                    <path
                        fill='fill'
                        d='m8 9.975-3.066 3.05-1.235-1.235 4.302-4.302 4.301 4.302-1.235 1.235-3.066-3.05Zm0-4.523-3.066 3.06-1.235-1.235 4.302-4.302 4.301 4.302-1.235 1.235-3.066-3.06Z'
                    />
                </g>
            </SvgIcon>
        );
    }
);
